'use strict';

module.exports = {
    getConfig: function (key) {
        let config = window.jsConfig || {};
        if (!(key in config)) {
            console.warn(`SFCC warning - getConfig(key): "${key}" is not configured yet and is not ready for usage.`);
        }
        return config[key];
    }
};
